// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import { getMessaging, onMessage } from "firebase/messaging"
import firebase from "firebase/app"


// import { firebase } from "firebase"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAIDkxVgDXdaSjRi0PBS9POntRaSfo7bEo",
  authDomain: "moc-dev-pushnotification.firebaseapp.com",
  projectId: "moc-dev-pushnotification",
  storageBucket: "moc-dev-pushnotification.appspot.com",
  messagingSenderId: "169943408638",
  appId: "1:169943408638:web:1faddbd3ca81005088eaaf",
  measurementId: "G-PXFV3BL4GY",
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)
export const messaging = getMessaging(app)
export const onMessageListener = () => {
  
  return new Promise((resolve) => {
   return onMessage(messaging, (payload) => {
      console.log("messaging--->",messaging,payload)
      return resolve(payload)
    })
  })
}




